
  import Vue from 'vue'
  import ActivityLogList from '@/components/admin/ActivityLogList.vue'

  export default Vue.extend({
    name: 'AdminActivityLogs',
    components: {
      ActivityLogList
    },
    created() {
      document.title = this.$vuetify.lang.t("$vuetify.tab_titles.admin_activity_logs")
    }
  })
